/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));



if(document.location.href.endsWith('/collections/all')) {
document.location.href = '/';
}

// Popup for Newsletter link
const newsletterLink = document.querySelector('a[href="#newsletter"]');

if (newsletterLink) {
    newsletterLink.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent the default anchor action
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'TznMT4']);
    });
}

// Popup for Newsletter link Turkish
const newsletterLinkTurkish = document.querySelector('a[href="/tr#newsletter"]');

if (newsletterLinkTurkish) {
    newsletterLinkTurkish.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent the default anchor action
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'U4s6eX']);
    });
}


// Popup for Newsletter link
const gwLinks = document.querySelectorAll('[href="#goldenweek"]');
if (gwLinks.length > 0) {
gwLinks.forEach((gwLink) =>
   gwLink.addEventListener('click', function (event) {
    console.log("clicked");
        event.preventDefault(); // Prevent the default anchor action
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UUCfXM']);
    }));
}

// Popup for Newsletter link Turkish
const gwLinksTurkish = document.querySelectorAll('[href="/tr#goldenweek"]');
if (gwLinksTurkish.length > 0) {
gwLinksTurkish.forEach((gwLink) =>
   gwLink.addEventListener('click', function (event) {
    console.log("clicked");
        event.preventDefault(); // Prevent the default anchor action
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'UHS8ES']);
    }));
}


// Essential Loyalty NWesletter add on
const target = document.querySelector('#honeypop-app');

if (target) {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('._Text_Heading_1rz9r_18').forEach(heading => {
      if (heading.textContent.trim().includes('Zum Newsletter anmelden')) {
        const goldText = heading.parentElement.querySelector('._Text_1rz9r_1');

        if (goldText && !goldText.textContent.includes('20€ Gutschein')) {
          const span = document.createElement('span');
          span.textContent = ' & 20€ Gutschein';
          span.style.color = '#8d7135';
          span.style.fontWeight="400";
          span.style.marginLeft = '6px';
          goldText.appendChild(span);
        }
      }
    });
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
